import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-contest-done",
  "use": "icon-contest-done-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"icon-contest-done\"><path stroke=\"#F7A600\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M13 20.074 17.782 26 29 16\" /><circle cx=\"20\" cy=\"20\" r=\"18.5\" stroke=\"#F7A600\" stroke-width=\"3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol